/* eslint-disable radix */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable import/no-extraneous-dependencies */
import { toast, ToastContainer } from 'react-toastify'
import { useState } from 'react'
import dayjs from 'dayjs'
import { ChevronRight } from '../../assets/icons/chevron right'
import { HeaderCard } from '../../components/HeaderCard/HeaderCard'
import { ChevronRightStyle } from '../../components/HeaderCard/HeaderCard.style'
import { Loading } from '../../components/Loading/Loading'
import { ContainerTitle, DivTitle } from '../../components/TitlePage/TitlePage'
import { Tour } from '../../components/Tour'
import TourPredicoes from '../../utils/JoyRide/tourPredicoes'
import { dateToBr } from '../../utils/transformDate'
import 'dayjs/locale/pt-br'

import {
  Div,
  DivCards,
  DivInput,
  Wrapper,
  Table,
  Container,
  ContainerSearch,
  Calendars,
  Filters,
  TypesFilter,
  FilterClient,
  FilterSalesPeople,
  OptionActive,
  Option,
  Filtro,
  DatePickerStyle,
  FiltersCalendar,
  TypesFilterCalendar,
  FilterCompanie,
  FilterStatus,
  FilterProduct,
  FilterSegmento,
  FilterCategoria,
  Export,
  Filtros,
  DivNomePercentual,
  Label,
  DivInputMarcarTodos,
  Search,
  InputStyle,
  DivInputMarcarTodosItenPagina,
  ContainerModalSend,
  SendStyle,
  Closed,
  DivChecked,
  TextoConfirmacao,
} from './Predictions.style'
import { usePrediction } from './usePrediction'
import { Pagination } from '../../components/Pagination/Pagination'
import { ArrowDown } from '../../assets/icons/arrowDown'
import { Button } from '../../components/SideBar/Menu.style'
import { UserPositioning } from '../../assets/icons/user-positioning'
import SelectCompanie from '../../components/MultipleSelect'
import SelectTexto from '../../components/MultipleSelect/SelectTexto'
import { rotuloCategoria } from '../../components/MultipleSelect/rotuloCategoria'
import { useFiltrosCatalogo } from '../../hooks/useFiltrosCatalogo'
import { UserBlack } from '../../assets/icons/userBlack'
import PeriodPicker from '../../components/Calendar/rangePicker'
import Tooltips from '../../components/Tooltip'
import { CityBlack } from '../../assets/icons/cityBlack'
import Status from '../../assets/icons/status'
import { AdProduct } from '../../assets/icons/ad-product'
import { ItemFilter } from '../../components/ItemFilter/ItemFilter'
import { SpanFilter, Ul } from '../../layouts/LayoutTable/LayoutTable'
import Clear from '../../assets/icons/clear'
import { FilePdfIcon } from '../../assets/icons/file-pdf'
import { Send } from '../../assets/icons/send'
import { CheckOneIcon } from '../../assets/icons/check-one'
import { Checkbox } from '../../components/Checkbox/Checkbox'
import { colors } from '../../theme'
import { CardIconTitle } from '../../components/CardIconTitle/CardIconTitle'
import {
  DivBotoes,
  DivImg,
  Buttons,
  BtnSave,
  Spinner,
} from '../../components/CriarPedido/styles'
import { CancelaPedido } from '../../components/CriarPedido/cancelarPedido'

export function Predictions() {
  // Buscado aqui, e nao dentro de usePrediction: o Dashboard tambem monta aquele hook (so para
  // pegar a data de hoje) e passaria a buscar um catalogo que nao usa.
  const { segmentos, categorias, carregandoCatalogo } = useFiltrosCatalogo()
  const {
    prediction,
    isLoading,
    goToPage,
    setCurrentPage,
    currentPage,
    setCalendarFim,
    setCalendarInicio,
    setClient,
    setSalesPeople,
    handleShowFilterClient,
    handleShowFilterSalesPeople,
    showClient,
    showSalesPeople,
    selectedOptionsSalesPeople,
    selectedOptionsClient,
    selectedOptionsEmpresas,
    selectedOptionsProdutos,
    handleShowFilterCompanie,
    showCompanies,
    setValueCompanieId,
    showStatus,
    handleShowStatus,
    showProducts,
    setValueProductId,
    handleShowProduto,
    statusChecked,
    handleCheckboxChange,
    statusCheckedTodos,
    setStatusCheckedFiltro,
    dataHoje,
    valueClient,
    setValueClient,
    valueSalesPeople,
    setValueSalesPeople,
    valueCompanie,
    setValueCompanie,
    valueProduct,
    setValueProduct,
    arrayClientes,
    arrayVendedores,
    arrayEmpresas,
    arrayProdutos,
    productArray,
    companieArray,
    salesPeopleArray,
    clientArray,

    vendedores,
    clients,
    companies,
    produto,

    handleFiltroCliente,
    handleFiltroVendedor,
    handleFiltroEmpresa,
    handleFiltroProduto,
    handleLimparFiltros,

    handleClienteFiltrado,
    handleVendedorFiltrado,
    handleEmpresaFiltrada,
    handleProdutoFiltrado,

    valueSegmento,
    setValueSegmento,
    valueCategoria,
    setValueCategoria,
    setSegmentoFiltrado,
    setCategoriaFiltrada,
    showSegmento,
    showCategoria,
    handleShowSegmento,
    handleShowCategoria,
    handleFiltroSegmento,
    handleSegmentoFiltrado,
    handleFiltroCategoria,
    handleCategoriaFiltrada,
    check,
    handleCheckboxPredicao,
    handleCheckboxPredicaoTodos,
    selectAll,
    predicaoPagina,
    setPredicaoPagina,
    handlePredicaoPagina,

    handleIsCriarPedidoMassa,
    isCriarPedidoMassa,
    criaPedidosEmMassa,
    isEnviandoMassa,

    isBaixaMassa,
    handleIsBaixaMassa,
    criaBaixasEmMassa,
    isBaixandoMassa,

    handleGerarPdfListagem,
    isGeneratingPdf,

    handleKeyClosed,
    cancelar,
    handleShowCancelar,
    instancia,
    setCheckWhatsApp,
    setCheckEmail,
    checkWhatsApp,
    checkEmail,
  } = usePrediction()

  const data = localStorage.getItem('dataInicio')
  const dataSelecionadaPredicao = data ? JSON.parse(data) : null
  const dataFormatada = dataSelecionadaPredicao
    ? dataSelecionadaPredicao.split('/')
    : []
  const dataValida = dataSelecionadaPredicao
    ? `${dataFormatada[1]}/${dataFormatada[0]}/${dataFormatada[2]}`
    : ''
  const formatData = dataValida ? dayjs(dataValida) : dayjs()
  const dataInicio = formatData.format('DD/MM/YYYY')
  const lastDayOfMonth = dayjs().endOf('month')
  const dataFim = lastDayOfMonth.format('DD/MM/YYYY')

  const [dateEnd, setDateEnd] = useState(dataFim)
  const [dateStart, setDateStart] = useState(dataInicio)

  const handleFiltroDataInicio = (event: string) => {
    localStorage.setItem('dataInicio', JSON.stringify(event))
    setDateStart(event)
  }

  return (
    <>
      <ToastContainer theme="dark" />
      <DivTitle id="saudacaoPredicao" color="black" size={22}>
        <ContainerTitle>
          Predições
          <ContainerTitle>
            <Tooltips icon={<Tour steps={TourPredicoes} />} text="Tour" />
          </ContainerTitle>
        </ContainerTitle>
      </DivTitle>
      <ContainerSearch>
        <Filtros>
          <TypesFilter>
            <Filters
              type="button"
              onKeyDown={handleKeyClosed}
              onClick={handleShowFilterClient}
            >
              <UserPositioning /> Cliente <ArrowDown />
            </Filters>
          </TypesFilter>
          {showClient && (
            <FilterClient onKeyDown={handleKeyClosed}>
              <Filtro>
                {isLoading ? (
                  <Loading contrast={false} />
                ) : (
                  <SelectCompanie
                    value={valueClient}
                    handle={handleFiltroCliente}
                    array={arrayClientes ? clients : []}
                  />
                )}
                <Button
                  buttonType="SMALL"
                  type="button"
                  onClick={() => {
                    handleClienteFiltrado(clientArray)
                    handleShowFilterClient()
                  }}
                >
                  Aplicar
                </Button>
              </Filtro>
            </FilterClient>
          )}
          <TypesFilter>
            <Filters
              type="button"
              onKeyDown={handleKeyClosed}
              onClick={handleShowFilterSalesPeople}
            >
              <UserBlack /> Vendedor <ArrowDown />
            </Filters>
          </TypesFilter>
          {showSalesPeople && (
            <FilterSalesPeople onKeyDown={handleKeyClosed}>
              <Filtro>
                {isLoading ? (
                  <Loading contrast={false} />
                ) : (
                  <SelectCompanie
                    value={valueSalesPeople}
                    handle={handleFiltroVendedor}
                    array={arrayVendedores ? vendedores : []}
                  />
                )}
                <Button
                  buttonType="SMALL"
                  type="button"
                  onClick={() => {
                    handleShowFilterSalesPeople()
                    handleVendedorFiltrado(salesPeopleArray)
                  }}
                >
                  Aplicar
                </Button>
              </Filtro>
            </FilterSalesPeople>
          )}
          <TypesFilter>
            <Filters
              type="button"
              onKeyDown={handleKeyClosed}
              onClick={handleShowFilterCompanie}
            >
              <CityBlack /> Empresa <ArrowDown />
            </Filters>
          </TypesFilter>
          {showCompanies && (
            <FilterCompanie onKeyDown={handleKeyClosed}>
              <Filtro>
                {isLoading ? (
                  <Loading contrast={false} />
                ) : (
                  <SelectCompanie
                    value={valueCompanie}
                    handle={handleFiltroEmpresa}
                    array={arrayEmpresas ? companies : []}
                  />
                )}
                <Button
                  buttonType="SMALL"
                  type="button"
                  onClick={() => {
                    handleShowFilterCompanie()
                    handleEmpresaFiltrada(companieArray)
                  }}
                >
                  Aplicar
                </Button>
              </Filtro>
            </FilterCompanie>
          )}
          <TypesFilter>
            <Filters
              type="button"
              onKeyDown={handleKeyClosed}
              onClick={handleShowStatus}
            >
              <Status /> Status <ArrowDown />
            </Filters>
          </TypesFilter>
          {showStatus && (
            <FilterStatus onKeyDown={handleKeyClosed}>
              <SpanFilter>Filtrar por: </SpanFilter>

              <div>
                <Ul>
                  <ItemFilter
                    top="2px"
                    checked={!statusCheckedTodos.includes('TODOS')}
                    onChange={() => {
                      handleCheckboxChange('TODOS')
                    }}
                    text="Todos"
                    id="all"
                  />
                  <ItemFilter
                    top="2px"
                    checked={statusChecked.includes('EM_ALTA')}
                    onChange={() => {
                      handleCheckboxChange('EM_ALTA')
                    }}
                    text="Em alta"
                    id="onHigh"
                  />
                  <ItemFilter
                    top="2px"
                    checked={statusChecked.includes('EM_BAIXA')}
                    onChange={() => {
                      handleCheckboxChange('EM_BAIXA')
                    }}
                    text="Em baixa"
                    id="low"
                  />
                  <ItemFilter
                    top="2px"
                    checked={statusChecked.includes('NEUTRO')}
                    onChange={() => {
                      handleCheckboxChange('NEUTRO')
                    }}
                    text="Neutro"
                    id="neutro"
                  />
                </Ul>
              </div>
              <Button
                buttonType="SMALL"
                type="button"
                onClick={() => {
                  setStatusCheckedFiltro(statusChecked)
                  handleShowStatus()
                }}
              >
                Aplicar
              </Button>
            </FilterStatus>
          )}
          <TypesFilter>
            <Filters
              type="button"
              onKeyDown={handleKeyClosed}
              onClick={handleShowProduto}
            >
              <AdProduct /> Produto <ArrowDown />
            </Filters>
          </TypesFilter>
          <TypesFilter>
            <Filters
              type="button"
              onKeyDown={handleKeyClosed}
              onClick={handleShowSegmento}
            >
              <UserPositioning /> Segmento <ArrowDown />
            </Filters>
          </TypesFilter>
          <TypesFilter>
            <Filters
              type="button"
              onKeyDown={handleKeyClosed}
              onClick={handleShowCategoria}
            >
              <AdProduct /> Categoria <ArrowDown />
            </Filters>
          </TypesFilter>
          {showProducts && (
            <FilterProduct onKeyDown={handleKeyClosed}>
              <Filtro>
                {isLoading ? (
                  <Loading contrast={false} />
                ) : (
                  <SelectCompanie
                    value={valueProduct}
                    handle={handleFiltroProduto}
                    array={arrayProdutos ? produto : []}
                  />
                )}
                <Button
                  buttonType="SMALL"
                  type="button"
                  onClick={() => {
                    handleShowProduto()
                    handleProdutoFiltrado(productArray)
                  }}
                >
                  Aplicar
                </Button>
              </Filtro>
            </FilterProduct>
          )}
          {showSegmento && (
            <FilterSegmento onKeyDown={handleKeyClosed}>
              <Filtro>
                <SelectTexto
                  opcoes={segmentos}
                  value={valueSegmento}
                  handle={handleFiltroSegmento}
                  placeholder="Selecione um ou mais segmentos"
                  carregando={carregandoCatalogo}
                  vazio="Nenhum segmento cadastrado"
                />
                <Button
                  buttonType="SMALL"
                  type="button"
                  onClick={() => {
                    handleShowSegmento()
                    handleSegmentoFiltrado(valueSegmento)
                  }}
                >
                  Aplicar
                </Button>
              </Filtro>
            </FilterSegmento>
          )}
          {showCategoria && (
            <FilterCategoria onKeyDown={handleKeyClosed}>
              <Filtro>
                <SelectTexto
                  opcoes={categorias}
                  value={valueCategoria}
                  handle={handleFiltroCategoria}
                  placeholder="Selecione uma ou mais categorias"
                  carregando={carregandoCatalogo}
                  vazio="Nenhuma categoria cadastrada"
                  rotulo={rotuloCategoria}
                />
                <Button
                  buttonType="SMALL"
                  type="button"
                  onClick={() => {
                    handleShowCategoria()
                    handleCategoriaFiltrada(valueCategoria)
                  }}
                >
                  Aplicar
                </Button>
              </Filtro>
            </FilterCategoria>
          )}
          <TypesFilter>
            <Export
              type="button"
              onKeyDown={handleKeyClosed}
              onClick={() => {
                handleLimparFiltros()
                handleCheckboxChange('TODOS')
                setCalendarInicio(dataHoje)
                setValueClient([])
                setValueSalesPeople([])
                setValueCompanie([])
                setValueProduct([])
                setClient([])
                setSalesPeople([])
                setValueProductId([])
                setValueCompanieId([])
                setStatusCheckedFiltro([])
                setValueSegmento([])
                setSegmentoFiltrado([])
                setValueCategoria([])
                setCategoriaFiltrada([])
              }}
            >
              <Clear />
              Limpar
            </Export>
          </TypesFilter>
          <TypesFilter>
            <Export
              type="button"
              disabled={isGeneratingPdf}
              onClick={() => {
                handleGerarPdfListagem()
              }}
            >
              <FilePdfIcon />
              {isGeneratingPdf ? 'Gerando PDF...' : 'Gerar PDF'}
            </Export>
          </TypesFilter>
          <TypesFilterCalendar>
            <FiltersCalendar onKeyDown={handleKeyClosed}>
              <Calendars>
                <DatePickerStyle>
                  Período:
                  <PeriodPicker
                    handlePeriodoSelecionado={(inicio, fim) => {
                      handleFiltroDataInicio(inicio)
                      setDateEnd(fim)
                    }}
                    defaultValue={[formatData, lastDayOfMonth]}
                    size="250px"
                  />
                </DatePickerStyle>

                <Button
                  buttonType="SMALL"
                  type="button"
                  onClick={() => {
                    setCalendarInicio(dateStart)
                    setCalendarFim(dateEnd)
                  }}
                >
                  Aplicar
                </Button>
              </Calendars>
            </FiltersCalendar>
          </TypesFilterCalendar>
        </Filtros>
      </ContainerSearch>

      <OptionActive>
        {selectedOptionsClient &&
          selectedOptionsClient.map(option => (
            <Option key={option}>
              <strong>Cliente: </strong>
              {option}
            </Option>
          ))}
        {selectedOptionsSalesPeople &&
          selectedOptionsSalesPeople.map(option => (
            <Option key={option}>
              <strong>Vendedor: </strong>
              {option}
            </Option>
          ))}
        {statusChecked &&
          statusChecked.map(option => (
            <Option key={option}>
              <strong>Status: </strong>
              {option}
            </Option>
          ))}

        {selectedOptionsEmpresas &&
          selectedOptionsEmpresas.map(option => (
            <Option key={option}>
              <strong>Empresa: </strong>
              {option}
            </Option>
          ))}
        {selectedOptionsProdutos &&
          selectedOptionsProdutos.map(option => (
            <Option key={option}>
              <strong>Produto: </strong>
              {option}
            </Option>
          ))}
        {valueSegmento.map(option => (
          <Option key={option}>
            <strong>Segmento: </strong>
            {option}
          </Option>
        ))}
        {valueCategoria.map(option => (
          <Option key={option}>
            <strong>Categoria: </strong>
            {option}
          </Option>
        ))}
      </OptionActive>
      {prediction.content && prediction.content.length > 0 ? (
        <DivInputMarcarTodosItenPagina>
          <DivInputMarcarTodos>
            <Checkbox
              top="1px"
              checked={selectAll}
              onChange={() => handleCheckboxPredicaoTodos()}
            />
            <Label htmlFor="">Marcar todos</Label>
          </DivInputMarcarTodos>

          <Search>
            <DivInput>
              <Label>Predições por pagina:</Label>

              <InputStyle
                value={predicaoPagina}
                type="number"
                border={colors.grey600}
                onChange={event => setPredicaoPagina(event.target.value)}
                sizeX="34px"
                sizeY="32px"
              />
            </DivInput>
            <Button
              buttonType="SMALL"
              type="button"
              onClick={() => {
                handlePredicaoPagina()
              }}
            >
              Aplicar
            </Button>
            <Button
              buttonType="SMALL"
              type="button"
              onClick={() => {
                if (check.length === 0) {
                  toast.error('Nenhuma predição selecionada')
                } else {
                  handleIsCriarPedidoMassa()
                }
              }}
            >
              Enviar pedido
            </Button>
            <Button
              buttonType="SMALL"
              type="button"
              onClick={() => {
                if (check.length === 0) {
                  toast.error('Nenhuma predição selecionada')
                } else {
                  handleIsBaixaMassa()
                }
              }}
            >
              Dar baixa
            </Button>
          </Search>
        </DivInputMarcarTodosItenPagina>
      ) : (
        ''
      )}
      {isLoading ? (
        <Loading contrast={false} />
      ) : (
        <>
          <DivCards key={JSON.stringify(prediction)}>
            {prediction.content &&
              prediction.content.map(item => (
                <Wrapper>
                  <Div>
                    <DivNomePercentual>
                      <Checkbox
                        top="0px"
                        checked={check.includes(item.id)}
                        onChange={() => handleCheckboxPredicao(item.id)}
                      />

                      <HeaderCard
                        status={item.classificacao}
                        title={item.nome}
                        percentual={String(item.percentual).replace('.', ',')}
                      />
                    </DivNomePercentual>
                    <ChevronRightStyle
                      onClick={() => goToPage(item.id)}
                      id="cardPredicaoProduto"
                      key={item.id}
                    >
                      <ChevronRight />
                    </ChevronRightStyle>
                  </Div>
                  <Container>
                    <Table>
                      <thead>
                        <tr>
                          <th>Produto</th>
                          <th>Próx. compra</th>
                        </tr>
                      </thead>
                      <tbody>
                        {item.produtos.map(produtos => (
                          <tr key={produtos.id}>
                            <td>{produtos.nome}</td>
                            <td>{dateToBr(produtos.proximaCompra)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Container>
                </Wrapper>
              ))}
          </DivCards>
          <Pagination
            pageNumber={currentPage}
            pageSize={prediction.totalElements}
            offSet={prediction.size}
            onClick={page => setCurrentPage(page)}
            label="clientes"
          />
        </>
      )}
      {isCriarPedidoMassa && (
        <ContainerModalSend>
          <SendStyle>
            <DivImg>
              <CardIconTitle
                icon={<Send />}
                background={colors.grey200}
                title="Enviar pedidos"
                color={colors.grey900}
              />
            </DivImg>
            <DivChecked>
              <DivInputMarcarTodos>
                <Label htmlFor="">Tipo de envio:</Label>
              </DivInputMarcarTodos>
              <DivInputMarcarTodos>
                <Checkbox
                  top="1px"
                  checked={checkEmail}
                  onChange={() => setCheckEmail(!checkEmail)}
                />
                <Label htmlFor="">Enviar por email</Label>
              </DivInputMarcarTodos>
              <DivInputMarcarTodos>
                <Tooltips
                  icon={
                    <Checkbox
                      top="1px"
                      checked={instancia.ativo ? checkWhatsApp : false}
                      onChange={() => setCheckWhatsApp(!checkWhatsApp)}
                      disabled={!instancia.ativo}
                      bloqueado={!instancia.ativo ? 'bloqueado' : ''}
                    />
                  }
                  text={instancia.ativo ? '' : 'Nenhuma instância conectada!'}
                />

                <Label htmlFor="">Enviar por whatsApp</Label>
              </DivInputMarcarTodos>
            </DivChecked>
            <DivBotoes>
              <Closed
                onClick={() => {
                  handleShowCancelar()
                }}
              >
                Cancelar
              </Closed>
              <Buttons>
                <BtnSave
                  type="button"
                  disabled={isEnviandoMassa}
                  onClick={() => {
                    if (!checkEmail && !checkWhatsApp) {
                      toast.error('Escolha pelo menos um tipo de envio!')
                    } else {
                      criaPedidosEmMassa()
                    }
                  }}
                >
                  {isEnviandoMassa ? (
                    <>
                      <Spinner />
                      Enviando...
                    </>
                  ) : (
                    'Enviar'
                  )}
                </BtnSave>
              </Buttons>
            </DivBotoes>
          </SendStyle>

          {cancelar && (
            <CancelaPedido
              texto="Deseja cancelar o pedido?"
              botaoNao={handleShowCancelar}
              botaoSim={handleIsCriarPedidoMassa}
            />
          )}
        </ContainerModalSend>
      )}
      {isBaixaMassa && (
        <ContainerModalSend>
          <SendStyle>
            <DivImg>
              <CardIconTitle
                icon={<CheckOneIcon />}
                background={colors.grey200}
                title="Dar baixa em massa"
                color={colors.grey900}
              />
            </DivImg>
            <DivChecked>
              <TextoConfirmacao>
                Deseja dar baixa em {check.length} cliente(s) selecionado(s)? Os
                produtos exibidos na listagem para esses clientes serão
                baixados, sem envio de pedido.
              </TextoConfirmacao>
            </DivChecked>
            <DivBotoes>
              <Closed
                onClick={() => {
                  handleIsBaixaMassa()
                }}
              >
                Cancelar
              </Closed>
              <Buttons>
                <BtnSave
                  type="button"
                  disabled={isBaixandoMassa}
                  onClick={() => {
                    criaBaixasEmMassa()
                  }}
                >
                  {isBaixandoMassa ? (
                    <>
                      <Spinner />
                      Dando baixa...
                    </>
                  ) : (
                    'Dar baixa'
                  )}
                </BtnSave>
              </Buttons>
            </DivBotoes>
          </SendStyle>
        </ContainerModalSend>
      )}
    </>
  )
}
